import createModel from 'utils/model'
import {
    groups,
    allStores,
    stores,
    getGroupList,
    saveGroup,
    editGroup,
    delGroup,
} from 'services/store'

const model = createModel({
    namespace: 'store',
    state: {},
    effects: {
        *groups(_, {call}) {
            return yield call(groups)
        },
        *allStores(_, {call}) {
            return yield call(allStores)
        },
        *stores({payload}, {call}) {
            return yield call(stores, payload)
        },
        *getGroupList({payload}, {call}) {
            return yield call(getGroupList, payload)
        },
        *saveGroup({payload}, {call}) {
            return yield call(saveGroup, payload)
        },
        *editGroup({payload}, {call}) {
            return yield call(editGroup, payload)
        },
        *delGroup({payload}, {call}) {
            return yield call(delGroup, payload)
        },
    },
    reducers: {},
})

export default model
